import { useNavigate, useParams } from "react-router-dom";
import { RUBRIQUES } from "../config/rubriques";

const useRubriqueNav = (rubriqueId) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const indexCourant = RUBRIQUES.findIndex((r) => r.id === rubriqueId);
  const precedente = RUBRIQUES[indexCourant - 1] || null;
  const suivante = RUBRIQUES[indexCourant + 1] || null;

  const buildPath = (rubrique) => rubrique.path.replace(":id", id);

  const goNext = () => { if (suivante) navigate(buildPath(suivante)); };
  const goPrev = () => { if (precedente) navigate(buildPath(precedente)); };
  const goTo   = (index) => {
    if (index >= 0 && index < RUBRIQUES.length) {
      navigate(buildPath(RUBRIQUES[index]));
    }
  };

  return {
    goNext,
    goPrev,
    goTo,
    suivante,
    precedente,
    indexCourant,
    total: RUBRIQUES.length,
    position: `${indexCourant + 1} / ${RUBRIQUES.length}`,
  };
};

export default useRubriqueNav;